/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Presets_None_TextInputs */

const en_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have not saved any transcript export presets yet.`)
};

const fr_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez encore enregistre aucun prereglage d'exportation de transcription.`)
};

const de_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben noch keine Exportvoreinstellungen für Transkripte gespeichert.`)
};

const it_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai ancora salvato alcun preset di esportazione della trascrizione.`)
};

const ru_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы еще не сохранили ни одного параметра экспорта стенограммы.`)
};

const es_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no has guardado ningún ajuste preestablecido de exportación de transcripción.`)
};

const zh_cn2_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您尚未保存任何转录导出预设。`)
};

const ja_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトのエクスポートプリセットがまだ保存されていません。`)
};

const hi_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपने अभी तक कोई भी ट्रांसक्रिप्ट एक्सपोर्ट प्रीसेट सेव नहीं किया है।`)
};

const pt_pt2_transcript_export_presets_none_text = /** @type {(inputs: Transcript_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não salvou nenhuma predefinição de exportação de transcrição.`)
};

/**
* | output |
* | --- |
* | "You have not saved any transcript export presets yet." |
*
* @param {Transcript_Export_Presets_None_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_presets_none_text = /** @type {((inputs?: Transcript_Export_Presets_None_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Presets_None_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_presets_none_text(inputs)
	if (locale === "de") return de_transcript_export_presets_none_text(inputs)
	if (locale === "it") return it_transcript_export_presets_none_text(inputs)
	if (locale === "ru") return ru_transcript_export_presets_none_text(inputs)
	if (locale === "es") return es_transcript_export_presets_none_text(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_presets_none_text(inputs)
	if (locale === "ja") return ja_transcript_export_presets_none_text(inputs)
	if (locale === "hi") return hi_transcript_export_presets_none_text(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_presets_none_text(inputs)
	return en_transcript_export_presets_none_text(inputs)
});